import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const mobileErrorTypeValues = [
  "UNKNOWN",
  "FILE_NOT_FOUND",
  "MISSING_EXPO_PUSH_TOKEN",
  "INVALID_EXPO_PUSH_TOKEN",
  "PUSH_NOTIFICATION_PROCESSING_FAILED",
  "SENTRY_DSN_NOT_FOUND",
  "SENTRY_NOT_ENABLED",
  "SENTRY_TEST_EVENT",
] as const;
const mobileErrorTypeSchema = z.enum(mobileErrorTypeValues);
const MobileErrorType = mobileErrorTypeSchema.enum;
type MobileErrorType = z.infer<typeof mobileErrorTypeSchema>;

export type MobileErrors =
  | { errorType: typeof MobileErrorType.UNKNOWN; data: undefined }
  | { errorType: typeof MobileErrorType.FILE_NOT_FOUND; data: { fileId: string } }
  | { errorType: typeof MobileErrorType.MISSING_EXPO_PUSH_TOKEN; data: undefined }
  | { errorType: typeof MobileErrorType.INVALID_EXPO_PUSH_TOKEN; data: { expoPushToken: string } }
  | { errorType: typeof MobileErrorType.PUSH_NOTIFICATION_PROCESSING_FAILED; data: { chunk: unknown } } // unknown because type come from an sdk
  | { errorType: typeof MobileErrorType.SENTRY_DSN_NOT_FOUND; data: undefined }
  | { errorType: typeof MobileErrorType.SENTRY_NOT_ENABLED; data: undefined }
  | { errorType: typeof MobileErrorType.SENTRY_TEST_EVENT; data: undefined };

export const mobileErrorDetails: Record<MobileErrorType, ErrorDetails> = {
  UNKNOWN: { classification: ErrorClassification.UNEXPECTED_ERROR, sentryDescription: "Unknown Error" },
  FILE_NOT_FOUND: { classification: ErrorClassification.NOT_FOUND_ERROR, sentryDescription: "File not found" },
  MISSING_EXPO_PUSH_TOKEN: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Missing Expo push token provided",
  },
  INVALID_EXPO_PUSH_TOKEN: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Invalid Expo push token provided",
  },
  PUSH_NOTIFICATION_PROCESSING_FAILED: {
    classification: ErrorClassification.INTEGRATION_ERROR,
    sentryDescription: "Failed to process push notification chunk",
  },
  SENTRY_DSN_NOT_FOUND: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Sentry DSN not found in environment variables",
  },
  SENTRY_NOT_ENABLED: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "isSentryEnabled returned false",
  },
  // Not UNEXPECTED_ERROR: that bucket is what made these deliberate test taps unfilterable in triage (NSYNC-7599).
  SENTRY_TEST_EVENT: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Deliberate test event from mobile admin tools",
  },
};
